<template>
  <vs-card>
    <vs-row class="head">
        <vs-col vs-w="12" vs-type="flex" vs-align="center">
          <h4>Napi menü státusz szöveg szerkesztése</h4>
        </vs-col>
        <vs-col vs-w="10" vs-type="flex" vs-align="center">
          <vs-input :disabled="!editMode" v-model="alertText.OptionValue" style="width: 100%;"></vs-input>
        </vs-col>
        <vs-col vs-w="2" vs-type="flex" vs-align="center" vs-justify="flex-end" style="margin-top: 15px;">
          <vs-button v-if="!editMode" radius color="warning" size="small" type="gradient" icon="build"
                    @click="editSetting()"></vs-button>
          <vs-button v-if="editMode" radius color="success" size="small" type="gradient" icon="check"
                    @click="save()"></vs-button>
          <vs-button v-if="editMode" radius color="danger" size="small" type="gradient" icon="clear"
                    @click="cancel()"></vs-button>
        </vs-col>
    </vs-row>
  </vs-card>
</template>

<script>

import {axiosInstance} from "@/main";

export default {
  name: "dailyAlert",
  data() {
    return {
      editMode: false,
      alertText: {}
    }
  },
  methods: {
    getSettings() {
      let self = this;
      axiosInstance
          .get("admin/optionsController.php?name=dailyMenuText", {
            withCredentials: true,
          })
          .then((resp) => {
            self.alertText = resp.data.responseData[0];
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    save() {
      let self = this;
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      axiosInstance
          .post('admin/optionsController.php', {
            id: self.alertText.Id,
            val: self.alertText.OptionValue
          }, {withCredentials: true})
          .then((resp) => {
            self.$vs.notify({
              title: 'Rendszerüzenet',
              position: 'top-right',
              text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
              color: resp.data.status === 'OK' ? 'success' : 'danger',
              icon: resp.data.status === 'OK' ? 'check_box' : 'error'
            });
            self.editMode = false;
            self.getSettings();
            self.$vs.loading.close();
          })
          .catch((err) => {
            self.$vs.loading.close();
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    editSetting() {
      this.editMode = true;
    },
    cancel() {
      this.getSettings();
      this.editMode = false;
    }
  },
  created() {
    this.getSettings();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>